import { FC } from 'react';
import styled, { css } from 'styled-components';

export type MessageProps = {
  isLarge: boolean;
};

const maxSize = 500;

const avatarMessageTextStyles = css`
  font-size: 16px;
  line-height: 19px;
  letter-spacing: 0.01em;
  margin-top: 16px;
`;

export const Error = styled.div`
  color: rgb(241, 57, 52);
  br {
    display: none;
  }
  ${avatarMessageTextStyles};
`;

export const FileRequirement = styled.div`
  color: #919eaa;
  br {
    display: none;
  }
  ${avatarMessageTextStyles};
`;

const Message: FC<MessageProps> = ({ isLarge }) =>
  isLarge ? (
    <Error>
      Your image is <br />
      larger than {maxSize} KB.
    </Error>
  ) : (
    <FileRequirement>
      Max {maxSize} KB
      <br /> .jpg .jpeg .png
    </FileRequirement>
  );

export default Message;
